import React from "react";
import Report from "../../../components/Report/Report";

const AuditReports = () => {
  return <Report type={"audit"} />;
};

export default AuditReports;
